module.exports = __webpack_public_path__ + "img/product_banner_building.9459e54c.png";